import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initProjectUserState: types.ProjectUserState = {
    projectUserList: null,

    assignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
    },
    notAssignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },

    reloadProjectUserList: true,
}

const projectUserReducer = produce((
    draft: types.ProjectUserState = initProjectUserState,
    action: ActionTypes = null,
): types.ProjectUserState => {
    switch (action.type) {
        case types.PROJECT_USER_LIST:
            draft.projectUserList = {
                ...draft.projectUserList,
                ...action.projectUserList,
            }
            return draft

        case types.ASSIGNED_PROJECT_USER_IDS:
            draft.assignedUsers.userIds = action.userIds
            return draft

        case types.ASSIGNED_PROJECT_USER_SORT:
            draft.assignedUsers.sortColumn = action.sortColumn
            draft.assignedUsers.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_PROJECT_USER_FILTERS:
            draft.assignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_IDS:
            draft.notAssignedUsers.userIds = action.userIds
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_SORT:
            draft.notAssignedUsers.sortColumn = action.sortColumn
            draft.notAssignedUsers.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_FILTERS:
            draft.notAssignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_SELECTED:
            draft.notAssignedUsers.selected = action.selected
            return draft

        case types.PROJECT_USER_RELOAD_LIST:
            draft.reloadProjectUserList = action.value
            return draft

        default:
            return draft
    }
})
export default projectUserReducer
